import {Brick, registerBrick} from 'olympe';

export default class InitGatewayRequest extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} select
     * @param {number} limit
     * @param {number} offset
     * @param {number} page
     * @param {boolean} count
     * @param {boolean} distinct
     * @param {boolean} useDisjunctiveForm
     * @param {function()} forwardEvent
     * @param {function(string)} setBody
     */
    update ($, [select, limit, offset, page, count, distinct, useDisjunctiveForm], [forwardEvent, setBody]) {
        const picksArray = select?.split(',');
        setBody(JSON.stringify({
            ... (this.objectIfDefined('select', picksArray)),
            ... (this.objectIfDefined('limit', limit)),
            ... (this.objectIfDefined('offset', offset)),
            ... (this.objectIfDefined('page', page)),
            ... (this.objectIfDefined('count', count)),
            ... (this.objectIfDefined('distinct', distinct)),
            ... (this.objectIfDefined('useDisjunctiveForm', useDisjunctiveForm))
        }));
        forwardEvent();
    }
    objectIfDefined (key, value) {
        return ((value !== undefined && value !== null) && {[key]: value});
    }
}

registerBrick('018a02b8bf256987ddd4', InitGatewayRequest);
